var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("el-card", { staticClass: "mb5" }, [
        _c(
          "div",
          { staticStyle: { "margin-bottom": "20px" } },
          [
            _c(
              "el-form",
              {
                ref: "formSearch",
                attrs: {
                  model: _vm.queryForm,
                  "label-position": "top",
                  size: "small",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("uploadFile.statisticsDate"),
                            },
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                "end-placeholder": _vm.$t(
                                  "operationCenter.endDate"
                                ),
                                "start-placeholder": _vm.$t(
                                  "operationCenter.startDate"
                                ),
                                "range-separator": "~",
                                type: "daterange",
                                "value-format": "yyyy-MM-dd",
                              },
                              model: {
                                value: _vm.queryDateTime,
                                callback: function ($$v) {
                                  _vm.queryDateTime = $$v
                                },
                                expression: "queryDateTime",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("collectionCenter.region") },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "placeOrder.pleaseChoose"
                                  ),
                                  clearable: "",
                                  filterable: "",
                                },
                                model: {
                                  value: _vm.queryForm.params.regionId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm.params,
                                      "regionId",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.params.regionId",
                                },
                              },
                              _vm._l(_vm.regionList, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label:
                                      item.zhName + "（" + item.puName + "）",
                                    value: item.id,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("collectionCenter.state") },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "GlobalSetObj.pleaseChoose"
                                  ),
                                  clearable: "",
                                  filterable: "",
                                  multiple: "",
                                },
                                model: {
                                  value: _vm.queryForm.params.states,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm.params,
                                      "states",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.params.states",
                                },
                              },
                              _vm._l(_vm.StateList, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: item.label,
                                    value: item.label,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("newOrder.CustomerName"),
                              name: "customerIds",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "GlobalSetObj.OnlyAreDisplayed"
                                  ),
                                  "remote-method": _vm.getCustomerPage,
                                  clearable: "",
                                  "collapse-tags": "",
                                  filterable: "",
                                  multiple: "",
                                  remote: "",
                                  "reserve-keyword": "",
                                },
                                on: {
                                  clear: function ($event) {
                                    return _vm.getCustomerPage("")
                                  },
                                  focus: function ($event) {
                                    return _vm.getCustomerPage("", true)
                                  },
                                },
                                model: {
                                  value: _vm.queryForm.params.customerIds,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm.params,
                                      "customerIds",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.params.customerIds",
                                },
                              },
                              _vm._l(_vm.customerList, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label:
                                      item.customerAlias +
                                      "(" +
                                      item.username +
                                      ")",
                                    value: item.id,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c(
                        "div",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-search",
                                size: "small",
                                type: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.searchResources(1)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("operationCenter.Procurar")) + " "
                              ),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-refresh-left",
                                size: "small",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.searchResources(2)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("operationCenter.reset")) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-upload2",
                                size: "small",
                                type: "primary",
                              },
                              on: { click: _vm.allExportOrder },
                            },
                            [_vm._v(_vm._s(_vm.$t("newOrder.export")) + " ")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "tableOpeatioLabel" }, [
              _vm._v(_vm._s(_vm.$t("uploadFile.missedOperationStatistics"))),
            ]),
            _c("div", { staticClass: "flx-between" }, [
              _c(
                "div",
                { staticStyle: { "text-align": "center", width: "20%" } },
                [
                  _c("div", [_vm._v(_vm._s(_vm.$t("trajectory.total")))]),
                  _c("div", { staticClass: "tableOpeation" }, [
                    _vm._v(
                      _vm._s(_vm.missOperationStatisticsData.missTotal || 0)
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticStyle: { "text-align": "center", width: "20%" } },
                [
                  _c("div", [_vm._v(_vm._s(_vm.$t("home.collection")))]),
                  _c("div", { staticClass: "tableOpeation" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.missOperationStatisticsData
                            .collectMissScanTotal || 0
                        ) +
                        " "
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticStyle: { "text-align": "center", width: "20%" } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.$t("uploadFile.collectionLoading"))),
                  ]),
                  _c("div", { staticClass: "tableOpeation" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.missOperationStatisticsData
                            .collectLoadMissScanTotal || 0
                        ) +
                        " "
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticStyle: { "text-align": "center", width: "20%" } },
                [
                  _c("div", [_vm._v(_vm._s(_vm.$t("GlobalSetObj.arrive")))]),
                  _c("div", { staticClass: "tableOpeation" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.missOperationStatisticsData
                            .arrivalMissScanTotal || 0
                        ) +
                        " "
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticStyle: { "text-align": "center", width: "20%" } },
                [
                  _c("div", [_vm._v(_vm._s(_vm.$t("GlobalSetObj.sender")))]),
                  _c("div", { staticClass: "tableOpeation" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.missOperationStatisticsData
                            .shipmentMissScanTotal || 0
                        ) +
                        " "
                    ),
                  ]),
                ]
              ),
            ]),
          ],
          1
        ),
      ]),
      _c(
        "el-card",
        [
          _c(
            "el-table",
            { attrs: { border: "" } },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.serial"),
                  align: "center",
                  type: "index",
                  width: "80",
                },
              }),
              _vm._l(_vm.columnList, function (item, ind) {
                return _c(
                  "el-table-column",
                  {
                    key: ind,
                    attrs: {
                      align: item.align,
                      "min-width": item.width,
                      prop: item.prop,
                      "show-overflow-tooltip": true,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [_vm._v(_vm._s(scope.row[item.prop]))]),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c("div", [_vm._v(_vm._s(item.label))]),
                    ]),
                  ],
                  2
                )
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.operate"),
                  align: "center",
                  fixed: "right",
                  width: "100px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              content: _vm.$t(
                                "customerManagements.detailTitle"
                              ),
                              effect: "dark",
                              placement: "top",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "iconfont icon-a-zu1279 clickDetail",
                              staticStyle: { "font-size": "24px" },
                              on: {
                                click: function ($event) {
                                  return _vm.clickDetail(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  "current-page": _vm.queryForm.pageNumber,
                  "page-size": _vm.queryForm.pageSize,
                  "page-sizes": [10, 20, 50, 100],
                  total: _vm.total,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "current-change": _vm.getCurrentTableData,
                  "size-change": _vm.getSizeTableData,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.$t("customerManagements.detailTitle"),
            visible: _vm.dialogVisible,
            center: "",
            direction: "ltr",
            size: "1400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.closeDrawer,
          },
        },
        [
          _vm.dialogVisible
            ? _c("packageDetail", {
                ref: "votesDetails",
                attrs: {
                  "package-detail-dta": _vm.packageDetailDta,
                  "region-list": _vm.regionList,
                  "state-list": _vm.StateList,
                },
                on: { "call-parent-method": _vm.parentMethod },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }